import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import React from "react";
import { useTranslation } from "react-i18next";

import NumericalInput from "../../Components/NumericalInput";
import {
  formatGoogleDriveMediaLink,
  getItemsInShipments,
} from "../../Utils/Common";
import SerialisedSubAssemblyAllocation, {
  getSerialisedSubAssemblyAllocationsForStockItem,
  isSerialisedSubAssemblyStockItem,
} from "../Shipments/SerialisedSubAssemblyAllocation";

export default function OrderLine({
  item,
  selectedProducts,
  setSelectedProducts,
  onlyPrint,
  serialNumberAllocation,
  editedOrder,
  totalPrice,
  setTotalPrice,
  width,
  serialisedSubAssemblyAllocation,
  shipmentData,
  setShipmentData,
}) {
  const { t } = useTranslation();
  width = onlyPrint ? "" : width;
  const reserveSerialisedSubAssemblyAllocationColumn =
    !!serialisedSubAssemblyAllocation;
  const showSerialisedSubAssemblyAllocation =
    reserveSerialisedSubAssemblyAllocationColumn &&
    isSerialisedSubAssemblyStockItem(item);
  const serialisedSubAssemblyAllocationMinimum =
    showSerialisedSubAssemblyAllocation
      ? getSerialisedSubAssemblyAllocationsForStockItem(
          shipmentData,
          item,
        ).length
      : 0;

  const validatePrice = (value) => {
    // Do not allow negative values (fixes bug where all the products are 100%)
    if (value < 0) {
      return 0;
    }
    return value;
  };

  const calculatePrice = (value, label, item) => {
    var num = Number(value);
    var it;
    var unitprice = 0;
    var unitcount = 0;
    if (!isNaN(item.costPrice)) {
      unitprice = item.costPrice;
    }
    if (!isNaN(item.count)) {
      unitcount = item.count;
    }
    var oldprice = unitcount * unitprice;
    if (label === "count") {
      if (serialisedSubAssemblyAllocationMinimum > num) {
        alert(
          t(
            "shipments.removeSerialisedSubAssembliesFirst",
            "You need to remove serialised sub-assembly allocations first!",
          ),
        );
        return;
      }
      setTotalPrice(validatePrice(totalPrice - oldprice + num * unitprice));
      it = { ...item, count: num };
      setSelectedProducts(
        selectedProducts.map((m) => (m.id === it.id ? it : m)),
      );
    } else if (label === "costPrice") {
      setTotalPrice(validatePrice(totalPrice - oldprice + num * unitcount));
      it = { ...item, costPrice: num };
      setSelectedProducts(
        selectedProducts.map((m) => (m.id === it.id ? it : m)),
      );
    }
  };

  return (
    <Grid
      container
      style={{
        borderRadius: 5,
        backgroundColor: "#eeeeee",
        marginTop: 2,
        padding: 5,
      }}
      alignItems="center"
    >
      {onlyPrint || width === "xs" ? null : (
        <>
          <Grid item xs={1} style={{ padding: 5 }}>
            <img
              alt="Item"
              src={formatGoogleDriveMediaLink(item.imageUrl)}
              width={50}
            />
          </Grid>
          <Grid item xs={3} style={{ padding: 5 }}>
            <Typography>{item.sku}</Typography>{" "}
          </Grid>
        </>
      )}
      <Grid
        item
        sm={
          onlyPrint
            ? 3 - (serialNumberAllocation ? 1 : 0)
            : reserveSerialisedSubAssemblyAllocationColumn
              ? 2
              : 3
        }
        xs={12}
        style={width === "xs" ? { marginBottom: 5 } : { padding: 5 }}
      >
        <Typography>{item.name}</Typography>
      </Grid>
      {reserveSerialisedSubAssemblyAllocationColumn ? (
        <Grid
          item
          sm={2}
          xs={12}
          style={width === "xs" ? { marginBottom: 5 } : { padding: 5 }}
        >
          {showSerialisedSubAssemblyAllocation ? (
            <SerialisedSubAssemblyAllocation
              stockItem={item}
              shipmentData={shipmentData}
              setShipmentData={setShipmentData}
              editable={true}
            />
          ) : null}
        </Grid>
      ) : null}
      <Grid
        item
        sm={onlyPrint ? 2 : 1}
        xs={4}
        style={width === "xs" ? {} : { padding: 5 }}
      >
        {onlyPrint ? (
          <Typography style={{ textAlign: "right" }}>
            {editedOrder?.Shipments?.length
              ? getItemsInShipments(editedOrder, item) + " / "
              : ""}{" "}
            {item.count}
          </Typography>
        ) : (
          <NumericalInput
            label={t("count")}
            type="number"
            key={item.id}
            defaultValue={Number(item.count)}
            inputProps={{ min: serialisedSubAssemblyAllocationMinimum || 0 }}
            variant="outlined"
            onChange={(e) => {
              calculatePrice(e.target.value, "count", item);
            }}
          />
        )}
      </Grid>
      <Grid
        item
        sm={onlyPrint ? 2 : 1}
        xs={4}
        style={width === "xs" ? {} : { padding: 5 }}
      >
        {onlyPrint ? (
          <Typography style={{ textAlign: "right" }}>
            {item.costPrice}
          </Typography>
        ) : (
          <NumericalInput
            label={t("orders.unitPrice")}
            type="number"
            key={item.id}
            inputProps={{ min: 0 }}
            variant="outlined"
            defaultValue={item.costPrice ? Number(item.costPrice) : ""}
            onChange={(e, v) => {
              calculatePrice(e.target.value, "costPrice", item);
            }}
          />
        )}
      </Grid>
      <Grid
        item
        sm={1 + (onlyPrint ? 1 : 0)}
        xs={2}
        style={{ padding: 5, textAlign: "right" }}
      >
        <Typography>
          {(isNaN(item.count * item.costPrice)
            ? 0
            : item.count *
              item.costPrice *
              (item.discount ? 1 - item.discount / 100 : 1)
          ).toFixed(2)}
        </Typography>
      </Grid>
      <Grid item sm={1} xs={3} style={{ padding: 5 }}>
        {onlyPrint ? null : (
          <Button
            color="secondary"
            variant="contained"
            size="small"
            onClick={() => {
              if (!showSerialisedSubAssemblyAllocation) {
                calculatePrice(0, "count", item);
              }
              setSelectedProducts([
                ...selectedProducts.filter((d) => d.id !== item.id),
              ]);
            }}
          >
            {t("remove")}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
